/**
 * AKINOD — Consulté récemment
 *
 * Le site historique montrait, sous chaque fiche, les quatre dernières fiches
 * vues pendant la visite : la plus récente en tête, sans celle en cours, une
 * fiche revue repassant devant (templates/v-new/produit.php:572-615, relevé sur
 * akinod.fr le 15/09). Même règle ici.
 *
 * La liste vit dans le navigateur : des identifiants de fiches, rien de
 * personnel. Les cartes viennent de la boutique, par une recherche sur ces
 * identifiants rendue par la section `akinod-vus-recemment-cartes` — le chemin
 * qu'Horizon prend pour les produits vus de sa recherche. L'identifiant ne
 * change pas d'une langue à l'autre, l'adresse d'une fiche si ; et une fiche
 * retirée de la vente n'est simplement plus trouvée.
 */
(() => {
  'use strict';

  const CLE = 'akinod:vus-recemment';
  const SECTION_CARTES = 'akinod-vus-recemment-cartes';
  // Plus que les quatre montrées : une fiche retirée de la vente laisse sa place
  // à la précédente, comme sur le site historique.
  const EN_MEMOIRE = 12;
  const MONTREES = 4;

  // Stockage refusé (navigation privée, réglages) : la fiche reste intacte,
  // simplement sans la section.
  function lire() {
    try {
      const liste = JSON.parse(window.localStorage.getItem(CLE) || '[]');
      return Array.isArray(liste) ? liste.map(String).filter((id) => /^\d+$/.test(id)) : [];
    } catch {
      return [];
    }
  }

  function retenir(liste) {
    try {
      window.localStorage.setItem(CLE, JSON.stringify(liste.slice(0, EN_MEMOIRE)));
    } catch {
      /* stockage indisponible : on n'insiste pas */
    }
  }

  /**
   * Les cartes que la boutique a trouvées, par identifiant de fiche, et la
   * feuille de style qui les accompagne : Shopify ne sert sur une page que les
   * styles des fichiers qu'elle rend, et la fiche ne rend aucune carte.
   */
  async function cartes(recherche, ids) {
    const url = new URL(recherche, window.location.origin);
    url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('type', 'product');
    url.searchParams.set('section_id', SECTION_CARTES);

    try {
      const reponse = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!reponse.ok) return { trouvees: new Map(), styles: null };

      const page = new DOMParser().parseFromString(await reponse.text(), 'text/html');
      return {
        trouvees: new Map([...page.querySelectorAll('template[data-ak-vus-id]')].map((modele) => [modele.dataset.akVusId, modele])),
        styles: page.querySelector('style[data-section-stylesheet]'),
      };
    } catch {
      return { trouvees: new Map(), styles: null };
    }
  }

  async function demarrer(section) {
    if (section.dataset.akVusPret) return;
    section.dataset.akVusPret = '1';

    const courante = section.dataset.produit || '';
    const avant = lire().filter((id) => id !== courante);

    // La fiche en cours passe en tête pour les pages suivantes, jamais sur la sienne.
    if (courante) retenir([courante, ...avant]);
    if (!avant.length) return;

    const { trouvees, styles } = await cartes(section.dataset.recherche || '/search', avant);
    const montrees = avant.filter((id) => trouvees.has(id)).slice(0, MONTREES);
    const grille = section.querySelector('[data-ak-vus-grille]');
    if (!montrees.length || !grille) return;

    // Posée juste avant le cadre, dans l'enveloppe de la section : l'éditeur de
    // thème la retire avec elle quand il réinjecte la section.
    if (styles) {
      styles.dataset.akVusStyles = '';
      section.parentElement?.querySelector(':scope > style[data-ak-vus-styles]')?.remove();
      section.before(styles);
    }

    grille.replaceChildren(...montrees.map((id) => document.importNode(trouvees.get(id).content, true)));
    section.hidden = false;

    // Défilement des visuels, flèches et puces des cartes, comme après
    // « Afficher plus » : tout vient de `.ak-scroller`.
    window.AkinodBehaviors?.boot(grille);
  }

  function toutDemarrer(racine) {
    if (racine instanceof Element && racine.matches('[data-ak-vus]')) demarrer(racine);
    racine.querySelectorAll?.('[data-ak-vus]').forEach((section) => demarrer(section));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => toutDemarrer(document), { once: true });
  } else {
    toutDemarrer(document);
  }

  // L'éditeur de thème réinjecte la section sans recharger la page.
  document.addEventListener('shopify:section:load', (e) => toutDemarrer(e.target));
})();
